/** @flow */
import {
  GetAbsenceNow,
  GetAbsenceNowSuccess,
  GetAbsenceNowError,
  GetToolsDashboard,
  GetToolsDashboardSuccess,
  GetToolsDashboardError,
  GetActivityFeedDashboard,
  GetActivityFeedDashboardSuccess,
  GetActivityFeedDashboardError,
  GetFirstCareIndexPageStatistic,
  GetFirstCareIndexPageStatisticSuccess,
  GetFirstCareIndexPageStatisticError,
  GetCoronavirusToolsDashboardSuccess,
  GetCoronavirusToolsDashboardError,
  GetCoronavirusToolsDashboard,
  GetHierarchyBreakdown,
  GetHierarchyBreakdownSuccess,
  GetHierarchyBreakdownError,
  GetRecentActivityFeedDashboard,
  GetRecentActivityFeedDashboardSuccess,
  GetRecentActivityFeedDashboardError,
} from "@modules/reporting/constants/actions";
import * as dashboardReducers from "./reducers";
import initialState from "./state";
import type { DashboardState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: DashboardState = initialState, action: Object): DashboardState => {
  const act = {
    [GetAbsenceNow]: dashboardReducers.onGetAbsenceNow,
    [GetCoronavirusToolsDashboard]: dashboardReducers.setLoading,
    [GetAbsenceNowSuccess]: dashboardReducers.onGetAbsenceNowSuccess,
    [GetAbsenceNowError]: dashboardReducers.onGetAbsenceNowError,
    // Tools Dashboard
    [GetToolsDashboard]: dashboardReducers.onGetToolsDashboard,
    [GetToolsDashboardSuccess]: dashboardReducers.onGetToolsDashboardSuccess,
    [GetToolsDashboardError]: dashboardReducers.onToolsDashboardError,
    // Activity Feed Dashboard
    [GetActivityFeedDashboard]: dashboardReducers.setLoading,
    [GetActivityFeedDashboardSuccess]: dashboardReducers.onGetActivityFeedDashboardSuccess,
    [GetActivityFeedDashboardError]: dashboardReducers.onToolsDashboardError,
    // Recent Activity Feed Dashboard
    [GetRecentActivityFeedDashboard]: dashboardReducers.setLoading,
    [GetRecentActivityFeedDashboardSuccess]:
      dashboardReducers.onGetRecentActivityFeedDashboardSuccess,
    [GetRecentActivityFeedDashboardError]: dashboardReducers.onToolsDashboardError,
    [GetFirstCareIndexPageStatistic]: dashboardReducers.onGetFirstCareIndexPageStatistic,
    [GetFirstCareIndexPageStatisticSuccess]:
      dashboardReducers.onGetFirstCareIndexPageStatisticSuccess,
    [GetFirstCareIndexPageStatisticError]: dashboardReducers.onToolsDashboardError,
    // Corona virus Dashboard
    [GetCoronavirusToolsDashboardSuccess]: dashboardReducers.onGetCoronavirusToolsDashboardSuccess,
    [GetCoronavirusToolsDashboardError]: dashboardReducers.onToolsDashboardError,

    [GetHierarchyBreakdown]: dashboardReducers.onGetHierarchyBreakdown,
    [GetHierarchyBreakdownSuccess]: dashboardReducers.onGetHierarchyBreakdownSuccess,
    [GetHierarchyBreakdownError]: dashboardReducers.onGetHierarchyBreakdownError,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
